import _, { forEach } from 'lodash-es'
import { BusinessArea } from '../../../services/AuthService';
import { LegalOnHoldModalController } from './LegalOnHoldModalController'

export class ApplicantDataController {

    lastActivityDate: Date
    lastActivityType: string
    legalArea: boolean
    canRePublish: boolean = false;
    public alerts: Array<Object> = [];
    public pendingRequest: boolean;
    public availableEvents: any[] = [];
    attendedEvents: any[] = [];

    static $inject = ['$uibModal', 'dialogs', 'GdprStatus', 'Auth', '$scope', 'userLastLogin', 'userAgreements', 'gdprStatus', 'userStatus', 'UserAccount', 'applicantDataReplication', 'RePublishShare', 'applicationId', 'ReviewApplication', 'trainingAccountDetails', 'Events', 'Activity']
    constructor(private $uibModal, private dialogs, private GdprStatus, Auth, private $scope, userLastLogin, private userAgreements, private gdprStatus, private userStatus, private UserAccount, private applicantDataReplication, private RePublishShare, private applicationId, private ReviewApplication, private trainingAccountDetails, private Events, private Activity) {
        this.legalArea = Auth.isInBusinessArea(BusinessArea.LEGAL);

        this.Activity.lastApplicantActivity({ applicationId: this.applicationId })
        .$promise
        .then(data => {
            this.lastActivityDate = data.activityDate
            this.lastActivityType = data.activityType
        });

        this.Events.applicationEvents({ applicationId: this.applicationId })
        .$promise
        .then(attEvents => {
            this.availableEvents = attEvents;

            this.availableEvents.forEach(ev => {
                ev.attended = ev.attendedEventId === ev.eventId;

                if(ev.attended){
                    this.attendedEvents.push(ev);
                }
            });
        });

        if (Auth.user.isOfficer) {
            this.ReviewApplication
                .canRePublishShare({ applicationId: this.applicationId })
                .$promise
                .then((result) => {
                    if (result.error && result.error.length>0) {
                        this.canRePublish = false;//displayerroronclick
                    }
                });

            this.ReviewApplication.canRePublishShare({
                applicationId: this.applicationId
            }, {
                //do nothing
            }, (data) => {
                this.canRePublish = true;
            }, (data) => {
                if (data.status === 409) {
                    this.pendingRequest = false;
                    this.alerts = data.data;
                }
            })
        }

    }

    unlock() {
        this.UserAccount
            .unlock()
            .$promise
            .then(_ => {
                this.userStatus.isLockedOut = false;
            });
    }

    rePublishShare() {
        this.ReviewApplication.canRePublishShare({
                applicationId: this.applicationId
            }, {
                //do nothing
            }, (data) => {
            this.RePublishShare
                .publsh({ applicationId: this.applicationId })
                .$promise
                .then(() => {
                    //refresh grid data
                    //question after sometime it will update. It is coming from share. so we should write notify from push service
                    //this.$scope.$parent.$broadcast('applicationCommentsChange', null);
                });
            }, (data) => {
                if (data.status === 409) {
                    this.pendingRequest = false;
                    this.dialogs.error('Validation Error', data.data);
                }
            })
       
    }

    changeLegalOnHold() {
        return this.$uibModal
            .open({
                templateUrl: 'areas/application/applicantData/legalOnHoldModal.html',
                controller: LegalOnHoldModalController,
                controllerAs: '$ctrl',
                backdrop: false,
                resolve: {
                    gdprStatus: () => angular.copy(this.gdprStatus)
                }
            })
            .result
            .then((results) => {
                this.gdprStatus = results;
            });

    }

    changeAttendedEvents(event: any)
    {
        if(event.attended){
            if(!_.includes(this.attendedEvents, { eventId: event.eventId })){
                this.attendedEvents.push(event);
            }
        } else {
            _.remove(this.attendedEvents, (ev) => ev.eventId === event.eventId);
        }
    }

    save()
    {
        this.Events
            .saveAttendedEvents({ applicationId: this.applicationId }, this.attendedEvents)
            .$promise
            .then(() => {
                this.dialogs.notify('Applicant Data', 'Changes were saved.');
            });

            this.$scope.applicantDataForm.$setPristine();
    }
}


angular
    .module('app')
    .controller('ApplicantData', ApplicantDataController);

